<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>K9-R Interaction Intent Prediction</h1>
        </div>
        <div class="picture">
          <img src="../assets/project15_1.jpg.webp" />
        </div>
        <div class="paper_published">
          Gong, Q.*, Chen, C., Wang, K., Li, C., Qin, Y., Qiao, X., Zou, N. (2026). From Service Dogs to Robots: A Bio-inspired Framework for Intuitive Intent Prediction in Mixed Reality, International Journal of Human–Computer Interaction, 1-19（TOP顶刊，SCI&CCF-B，Q1，唯一一作）
        </div>

        <div class="abstract">
          This project proposes an interaction intent prediction framework inspired by human-service dog collaboration, aiming to improve the intuitiveness and usability of human-quadruped robot interaction.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project15_2.jpeg.webp" />
          <br /><br /><img src="../assets/project15_3.jpeg.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">1 Introduction</div>
        <div class="text">
          With the rapid development of quadruped robots, their application scenarios have gradually shifted from military and search-and-rescue fields to domestic services. However, traditional human-robot interaction (HRI) methods rely too much on single-modal speech or complex commands, which are not intuitive enough and lead to poor user experience. Inspired by the long-term co-evolved natural interaction paradigm between humans and service dogs, this study aims to migrate this bionic interaction mode to human-quadruped robot control. It intends to use Mixed Reality (MR) technology to build an interaction environment, construct a multimodal intent prediction model based on Bayesian approach, and solve the problems of low operational efficiency, insufficient emotional resonance and low usability in existing HRI systems, so as to provide a scalable and intuitive control framework for service robots.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">2 Methods</div>
        <div class="text">
          First, a pilot study was conducted through interviews and video observation with service dog owners to extract core interaction rules and behavioral characteristics. Then, an MR data collection environment based on HoloLens 2 and virtual service dogs was built, and 37 valid participants were recruited to complete interactive tasks in four scenarios: acquaintance, self-help, helping others and behavior management. The multimodal data including speech, gesture and body posture were collected and processed, and the features were encoded and screened to retain three main modalities. A hierarchical Bayesian network intent prediction model was constructed with maximum likelihood estimation and Laplace smoothing, and the model achieved good top-3 prediction accuracy. Finally, the model was deployed into the MR-based robot control system (IIP), and 32 new participants were recruited to compare it with the pure speech (SI) and standard speech-gesture (SGI) systems. The operational efficiency, emotional experience (PAD scale) and system usability (SUS scale) were evaluated through within-group experiments.
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project15_4.jpeg.webp" />
          <br /><br /><img src="../assets/project15_5.jpeg.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project15_6.jpeg.webp" />
          <br /><br /><img src="../assets/project15_7.jpeg.webp" />
          <br /><br /><img src="../assets/project15_8.jpeg.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">3 Conclusion</div>
        <div class="text">
          This study verifies the feasibility of migrating the human-service dog interaction paradigm to quadruped robot control. The proposed Bayesian-based multimodal intent prediction model (IIP) is significantly better than traditional pure speech and standard multimodal interfaces in operational efficiency, user emotional experience and system usability. The use of MR technology reduces the cost of experimental development and provides a first-person immersive interaction perspective. Theoretically, it provides a new bionic design logic for HRI; practically, it enables non-expert users to intuitively control robots. The limitations are the small and youth-biased sample size and the virtual environment only. Future work will expand the sample, test on physical robots, and upgrade the model with deep learning to further improve the performance of the interaction system.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project15",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}

.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 6px;
  color: #333333;
}
</style>
